module.exports = __webpack_public_path__ + "img/infoIcon.c1db0746.svg";